/*
 * This illustrates how to modify the LoadOrdersHandler in a number of different ways.
 * The LoadOrdersHandler is used by the order history page to load order data
 */

import
    {
    addToChainAfter,
} from "@insite/client-framework/HandlerCreator";

import { chain ,SetCart} from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/SetInitialValues";
import { checkoutShippingTracking } from "@MasterBluePrint/tracking";


// this will enable HMR for custom handlers
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}

addToChainAfter(chain, SetCart,  props =>
{
   // checkoutShippingTracking(props.cart);
    
});

